import React from 'react';
import SubPageHeader from '../components/common/SubPageHeader';

const Partnership = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      {/* 1. Header with dynamic title */}
      <SubPageHeader title="Partnership" />

      {/* 2. Main Content Section */}
      <div className="container mx-auto px-4 py-16 flex justify-center">
        {/* Blue Border Container matching the image */}
        <div className="w-full max-w-5xl border-[3px] border-[#002147] rounded-[40px] p-8 md:p-12 shadow-2xl bg-white text-[#002147]">
          
          <div className="text-center space-y-6 text-lg md:text-xl font-medium leading-relaxed">
            <p>Every person has a unique ability with which he or she can spread happiness in this world.</p>
            
            <p>We would love to give you platform to share all your wisdom, knowledge, experience in the field of your expertise.</p>
            
            <p>Your expertise can be anything from cooking, hair dressing, website or app making to any invention or a patent.</p>
            
            <p>What could be better than receiving a handsome return on investment on your expertise along with making souls happy with it.</p>
            
            <p>Money with celebrity status -a face to be known along with eternal satisfaction.</p>
            
            <p>We have given a <a href="#" className="text-blue-600 underline">masterlist</a> for your guidance to find your USP.</p>
            
            <p>But you can always have a different course altogether from the provided <a href="#" className="text-blue-600 underline">masterlist</a>.</p>
            
            <p>If you have a course already designed with proper sequence and in the digital form we can directly share it on our platform.</p>
            
            <p>If you don't know how to start with a sequence and end, we are there to help you start from a scratch.</p>
            
            <p>Click for the right option and we will get back to you for you to spread happiness with a handsome ROI for your knowledge.</p>
            
            <p>Your course will have a chance to be seen by the right people... in any niche and any corner of the planet... thanks to worldwide traffic we will push to the searchable directory.</p>
            
            <p>You don't have to be good at technology to thrive in the virtual economy. We took that mystery away so you can focus on what you're already good at, and get up and running in record time without the complexity.</p>
            
            <p>Leave a legacy of all your knowledge and thoughts for deacades, to be followed by all the deserving souls.</p>
            
            <p className="text-2xl font-bold pt-6">LETS MAKE YOU FAMOUS!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partnership;